import { FormControl, FormControlLabel, Switch as MuiSwitch } from '@mui/material';
import type { WidgetProps } from 'app/schema-form/types';
import { getWidgetId, useWidgetTitle } from 'app/schema-form/util/widget';
import type React from 'react';
import type { ChangeEvent } from 'react';
import FieldInfo from '../../field-info/index.js';
import Widget from '../widget.js';

export type SwitchOwnProps = WidgetProps;

export type SwitchContainerProps = {
  readonly handleChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

export type SwitchProps = SwitchOwnProps & SwitchContainerProps;

export const Switch: React.FC<SwitchProps> = (props) => {
  const { schema, config, value, disabled, handleChange, error } = props;

  const enabled = typeof value === 'boolean' ? value : schema.get('default', false);
  const title = useWidgetTitle(props);
  const id = getWidgetId(props);
  const description = schema?.get('description');
  const instructions = config?.get('instructions');

  return (
    <Widget>
      <FormControl fullWidth error={Boolean(error)}>
        <FormControlLabel
          label={title}
          control={<MuiSwitch onChange={handleChange} checked={enabled} disabled={disabled} data-testid={id} />}
        />
        <FieldInfo description={description} instructions={instructions} error={error} />
      </FormControl>
    </Widget>
  );
};
